import { render } from "./ClippingAnimation.vue?vue&type=template&id=8e9d967e&ts=true"
import script from "./ClippingAnimation.vue?vue&type=script&lang=ts"
export * from "./ClippingAnimation.vue?vue&type=script&lang=ts"

import "./ClippingAnimation.vue?vue&type=style&index=0&id=8e9d967e&lang=scss"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__